import { ReactNode } from "react";
import { cn } from "@/lib/utils";

export const InfoWithCta = ({
  icon,
  title,
  cta,
  desc,
}: {
  icon: ReactNode;
  title: string;
  cta: ReactNode;
  desc?: string;
}) => {
  return (
    <div
      className={
        "relative flex flex-col items-center justify-center gap-6 overflow-hidden p-4"
      }
    >
      <div className="inline-flex h-12 w-12 items-center justify-center rounded-md bg-white p-2 shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] outline-1 outline-offset-[-1px] outline-zinc-200">
        {icon}
      </div>
      <div className={"flex flex-col items-center justify-center gap-4"}>
        <div
          className={cn(
            "text-center text-sm text-zinc-950",
            desc && "font-semibold",
          )}
        >
          {title}
        </div>
        {desc && (
          <div
            className={
              "mx-auto max-w-[300px] text-center text-sm text-zinc-500"
            }
          >
            {desc}
          </div>
        )}

        {cta}
      </div>
    </div>
  );
};
